const headers = [
  "Find your next jam.",
  "Discover an absolute banger.",
  "Expand your musical palate.",
  "Go on a sonic adventure.",
  "March to the beat of a new drum.",
  "Give your life a fresh melody.",
  "Tune in to something different.",
  "Let things take on a new refrain.",
  "Find yourself in a blissful harmony.",
  "Uncover a fresh bop.",
  "Turn up to a brand new tune.",
  "Dance your way through a novel number.",
  "Experience a phonetic revelation.",
  "Let yourself even the score.",
  "Revel in a rhythmic rhapsody.",
  "Give yourself something to croon about.",
  "Colour your world with a clean composition.",
  "Unearth your perfect verse.",
  "Strike an unfamiliar chord.",
  "Step it up an octave.",
  "Stir things up in a major way.",
  "Give your life a minor change.",
  // "scale",
  // "interlude",
  // "opus",
  // "sharp",
  // "encore",
  // "tone",
  // "accent",
  // "crescendo",
  // "flat",
  // "note",
  // "pitch",
  // "symphony",
  // "sublime stanza",
]

export default headers;